(function () {
  'use strict';

  angular.module('settings').factory('Settings', Settings);

  Settings.$inject = ['$resource'];

  function Settings($resource) {
    return $resource('/api/', {}, {});
  }
})();
